 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLSERIES from '@/components/xhtml/series'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLEDIT from '@/components/xhtml/edit'
 import XHTMLBOOK from '@/components/xhtml/book'
 import XHTMLJOURNY from '@/components/xhtml/journy'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLJOURNY01 from '@/components/xhtml/journy01'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLBIB from '@/components/xhtml/bib'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLAUTHOR01 from '@/components/xhtml/author01'
 import XHTMLBACK from '@/components/xhtml/back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/edit",
 			"name" : "xhtml/edit",
 			"component" : XHTMLEDIT
 		},
 		{
 			"path" : "/xhtml/book",
 			"name" : "xhtml/book",
 			"component" : XHTMLBOOK
 		},
 		{
 			"path" : "/xhtml/journy",
 			"name" : "xhtml/journy",
 			"component" : XHTMLJOURNY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js